<template>
  <div class="footer">
    <div>
      <img
        @click="home"
        class="logo"
        :src="require('@/assets/images/logo.png')"
      />
      <div class="col">
        <img class="icon" :src="require('@/assets/images/phone.png')" />
        <span>{{ phone }}</span>
      </div>
      <div class="col">
        <div>地址：</div>
        <span>{{ address }}</span>
      </div>
    </div>
    <div class="listBox">
      <div>
        <div class="first">关于瑞检</div>
        <div @click="skip('企业概况')">企业概况</div>
        <div @click="skip('企业动态')">企业动态</div>
        <div @click="skip('发展历程')">发展历程</div>
      </div>
      <div>
        <div class="first">服务支持</div>
        <div @click="skip('解决方案')">解决方案</div>
        <div @click="skip('产品展示')">产品展示</div>
      </div>
      <div>
        <div class="first">联系我们</div>
        <div @click="skip('联系经理')">联系经理</div>
        <div @click="skip('在线留言')">在线留言</div>
      </div>
    </div>
    <div class="copyright">
      {{ license }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      address: "",
      license: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.api.openConfig("website_phone").then((res) => {
        this.phone = res.data?.data?.remark;
      });
      this.api.openConfig("website_address").then((res) => {
        this.address = res.data?.data?.remark;
      });
      this.api.openConfig("website_icp_license").then((res) => {
        this.license = res.data?.data?.remark;
      });
    },
    home() {
      this.$router.push("/");
    },
    skip(value) {
      if (value === "企业概况") {
        this.$router.push("/AboutUs");
      } else if (value === "企业动态") {
        this.$router.push("/enterprise");
      } else if (value === "发展历程") {
        this.$router.push("/AboutUs");

        setTimeout(() => {
          document
            .getElementById("develop")
            .scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else if (value === "解决方案") {
        this.$router.push(`/Solution?id=${2}`);
      } else if (value === "产品展示") {
        this.$router.push(`/Solution?id=${1}`);
      } else if (value === "联系经理" || value === "在线留言") {
        this.$router.push("/");
        setTimeout(() => {
          document
            .getElementById("consultBox")
            .scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 1024px) {
  .footer {
    width: 100%;
    height: 230px;
    background: #1d2c51ff;
    position: relative;
    padding-top: 51px;
    display: flex;
    justify-content: space-around;
    > div {
      text-align: initial;
    }
    .copyright {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      opacity: 0.65;
      color: #ffffff;
      position: absolute;
      bottom: 19px;
      left: 50%;
      transform: translate(-50%);
    }
    .logo {
      width: 175px;
      height: 39px;
      margin-bottom: 24px;
      cursor: pointer;
    }
    .col {
      display: flex;
      align-items: center;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      color: #ffffff;
      margin-bottom: 15px;
      .icon {
        width: 11px;
        height: 11px;
      }
      span {
        margin-left: 6px;
      }
    }
    .listBox {
      display: flex;
      > div {
        margin-right: 70px;
        font-weight: 300;
        color: #ffffff;
        > div {
          font-size: 12px;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
      .first {
        font-size: 16px;
        font-weight: bold;
        cursor: auto;
      }
      > :last-child {
        margin-right: 0;
      }
    }
  }
}
@media (max-width: 1024px) {
  .footer {
    width: 100%;
    background: #1d2c51ff;
    position: relative;
    padding-top: 51px;
    color: #ffffff;
    .copyright {
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      color: #ffffff;
    }
    .logo {
      margin-bottom: 24px;
      width: 60%;
      cursor: pointer;
    }
    .col {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 300;
      color: #ffffff;
      margin-bottom: 15px;
      .icon {
        width: 11px;
        height: 11px;
      }
      span {
        margin-left: 6px;
      }
    }
    .listBox {
      display: flex;
      justify-content: center;
      > div {
        margin-right: 70px;
        font-weight: 300;
        color: #ffffff;
        > div {
          font-size: 11px;
          margin-bottom: 20px;
        }
      }
      .first {
        font-size: 16px;
        font-weight: bold;
      }
      > :last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
